import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { PlanesProvider, PlanHtml, ProyectQr } from '../../../providers/planes';
import { AuthProvider } from '../../../providers/auth';
import { User, UserDb } from '../../../providers/user';
import { environment } from '../../../../environments/environment.prod';
import { Router } from '@angular/router';
import { NotyPlan, NotificacionesProvider } from '../../../providers/notificaciones';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

    admin: boolean = false;
    qrs: ProyectQr[] = [];
    user: UserDb;
    userPlan: PlanHtml;
    url: string = environment.dominioUrl;

    messagePrevio = '';

    // admin
    notyfications: NotyPlan[] = [];

    constructor(private _auth: AuthProvider, private _planes: PlanesProvider, private _notys: NotificacionesProvider, private _user: User, public toastr: ToastsManager, public vcr: ViewContainerRef, private router : Router) {
        this.toastr.setRootViewContainerRef(vcr);
        this.admin = this._auth.userLoggend.role == 'admin';
        console.log('home');
        if(!this.admin){
            this.user = this._auth.userLoggend;
            console.log('user', this.user);
            this._planes.findByUserQrs(this._auth.userLoggend.id).then(qrsdb => {
                console.log('qrsdb', qrsdb);
                if(!qrsdb){
                    this.user.codigosQr.forEach(qr => {
                        this._planes.storeQr(this.user.id, qr).then(nQr => {
                            this.qrs.push(nQr);
                        });
                    });
                }else{
                    this.qrs = qrsdb;
                    /* qrsdb.forEach(qrDb => {
                        console.log(qrDb);
                        this._planes.storeRedirectPqr(this.user.id, qrDb);
                    }); */
                }
            })
        }else{
            console.log('es admin');
            this._notys.allNotyPlan().then(notys => {
                this.notyfications = notys;
                console.log(this.notyfications);
            });
            // this.router.navigate(['/usuarios']);
        }
    }

    aceptarNotyPlan(notyPlan: NotyPlan) {
        console.log(notyPlan);
        let newProyects: ProyectQr[] = [];
        for (let i = 0; i < notyPlan.plan.numProyects; i++) {
            let pQr = new ProyectQr();
            pQr.name += ' ' + (notyPlan.user.codigosQr.length + i + 1);
            pQr.carpetas[0].name = 'Default 1';
            
            this._planes.storeQr(notyPlan.user.id, pQr).then(nQr => {
                notyPlan.user.codigosQr.push(pQr);
                newProyects.push(nQr);
                if (notyPlan.plan.numProyects == newProyects.length) {
                    // guardar plan nuevo (solo es la key del plan) y proyectos en el usuario
                    notyPlan.user.planes.push(notyPlan.plan.id);
                    this._user.update(notyPlan.user).then(_ => {
                        // borrar noty plan
                        this._notys.deletePlan(notyPlan).then(r => {
                            this.notyfications = this.notyfications.filter(n => n.id != notyPlan.id);
                            console.log(notyPlan.user);
                            this.toastr.success('Se ha añadido el nuevo plan al usuario');
                        });
                    });
                }
            });
        }
    }

    cancelarNotyPlan(notyPlan: NotyPlan) {
        this._notys.deletePlan(notyPlan).then(r => {
            this.notyfications = this.notyfications.filter(n => n.id != notyPlan.id);
            this.toastr.success('Se ha cancelado la solicitud.');
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/dash/home/home.component.ts